import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: 'home',
      component: () => import('../views/home')  // 首页
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/home')  // 首页
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/about')  // 关于我们
    },
    {
      path: '/business',
      name: 'business',
      component: () => import('../views/business')  // 业务
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/contact')  // 联系我们
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('../views/test/demo')
    },
    {
      path: '/animation',
      name: 'animation',
      component: () => import('../views/test/animation')
    }
  ]
})

router.afterEach((to) => {
  window.scrollTo(0, 0);
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js